/**
 * minからmaxの間の連番が入った配列を生成する。
 * @param min number
 * @param max number
 * @returns number[]
 */
export const generateSequentialNumbers = (min: number, max: number) => {
  if (max < min) {
    return [];
  }
  const sizingArr = new Array(max - min + 1).fill(null);
  return sizingArr.map((_, i) => i + min);
};
